import React from "react";
import { Box, Typography } from "@mui/material";
export default function PrivacyPolicy() {
  return (
    <Box sx={{ padding: "10px 40px" }}>
      <Typography className="fs-24 text-center my">
        Privacy Policy
      </Typography>
      <Typography className="fs-20  my">Privacy Policy</Typography>
      {/* 1 */}
      <div className="my-10">
        <Typography className="fs-14">
          Last updated: January 1, 2025
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We use Your Personal data to provide and improve the Service. By using
          the Service, You agree to the collection and use of information in
          accordance with this Privacy Policy.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Interpretation and Definitions
        </Typography>
        <Typography className="fs-18">Interpretation</Typography>
        <Typography className="fs-14 text-justify my-10">
          The words of which the initial letter is capitalized have meanings
          defined under the following conditions. The following definitions
          shall have the same meaning regardless of whether they appear in
          singular or in plural.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-18">Definitions</Typography>
        <Typography className="fs-14 text-justify my-10">
          For the purposes of this Privacy Policy:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Account</b> means a unique account created for
            You to access our Service or parts of our Service.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Affiliate</b> means an entity that controls,
            is controlled by or is under common control with a party, where
            "control" means ownership of 50% or more of the shares, equity
            interest or other securities entitled to vote for election of
            directors or other managing authority.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Application</b> means the software program
            provided by the Company downloaded by You on any electronic device,
            named SIKI
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Business</b> for the purpose of the CCPA
            (California Consumer Privacy Act), refers to the Company as the
            legal entity that collects Consumers' personal information and
            determines the purposes and means of the processing of Consumers'
            personal information, or on behalf of which such information is
            collected and that alone, or jointly with others, determines the
            purposes and means of the processing of consumers' personal
            information, that does business in the State of California.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Company</b> (referred to as either "the
            Company", "We", "Us" or "Our" in this Agreement) refers to SIKI
            Holding Corp, 2376 Kimridge Road, CA 90210. For the purpose of the
            GDPR, the Company is the Data Controller.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Consumer</b> , for the purpose of the CCPA
            (California Consumer Privacy Act), means a natural person who is a
            California resident. A resident, as defined in the law, includes (1)
            every individual who is in the USA for other than a temporary or
            transitory purpose, and (2) every individual who is domiciled in the
            USA who is outside the USA for a temporary or transitory purpose.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Country</b> refers to: California, United
            States
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Data Controller</b> , for the purposes of the
            GDPR (General Data Protection Regulation), refers to the Company as
            the legal person which alone or jointly with others determines the
            purposes and means of the processing of Personal Data.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Device</b> means any device that can access
            the Service such as a computer, a cellphone or a digital tablet.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Do Not Track</b> (DNT) is a concept that has
            been promoted by US regulatory authorities, in particular the U.S.
            Federal Trade Commission (FTC), for the Internet industry to develop
            and implement a mechanism for allowing internet users to control the
            tracking of their online activities across websites.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Personal Data</b> is any information that
            relates to an identified or identifiable individual. For the
            purposes for GDPR, Personal Data means any information relating to
            You such as a name, an identification number, location data, online
            identifier or to one or more factors specific to the physical,
            physiological, genetic, mental, economic, cultural or social
            identity. For the purposes of the CCPA, Personal Data means any
            information that identifies, relates to, describes or is capable of
            being associated with, or could reasonably be linked, directly or
            indirectly, with You.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Sale</b>, for the purpose of the CCPA
            (California Consumer Privacy Act), means selling, renting,
            releasing, disclosing, disseminating, making available,
            transferring, or otherwise communicating orally, in writing, or by
            electronic or other means, a Consumer's personal information to
            another business or a third party for monetary or other valuable
            consideration.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Service</b> refers to the Application.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Service Provider</b> means any natural or
            legal person who processes the data on behalf of the Company. It
            refers to third-party companies or individuals employed by the
            Company to facilitate the Service, to provide the Service on behalf
            of the Company, to perform services related to the Service or to
            assist the Company in analyzing how the Service is used. For the
            purpose of the GDPR, Service Providers are considered Data
            Processors.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Third-party Social Media Service</b> refers to
            any website or any social network website through which a User can
            log in or create an account to use the Service.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Usage Data</b> refers to data collected
            automatically, either generated by the use of the Service or from
            the Service infrastructure itself (for example, the duration of a
            page visit).
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">You</b> means the individual accessing or
            using the Service, or the company, or other legal entity on behalf
            of which such individual is accessing or using the Service, as
            applicable. Under GDPR (General Data Protection Regulation), You can
            be referred to as the Data Subject or as the User as you are the
            individual using the Service.
          </li>
        </ul>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Collecting and Using Your Personal Data
        </Typography>
        <Typography className="fs-18">Types of Data Collected</Typography>
        <Typography className="fs-16">Personal Data</Typography>
        <Typography className="fs-14 text-justify my-10">
          While using Our Service, We may ask You to provide Us with certain
          personally identifiable information that can be used to contact or
          identify You. Personally identifiable information may include, but is
          not limited to:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">Email address</li>
          <li className="fs-14 text-justify my-10 text-white">
            First name and last name
          </li>
          <li className="fs-14 text-justify my-10 text-white">Phone number</li>
          <li className="fs-14 text-justify my-10 text-white">
            Address, State, Province, ZIP/Postal code, City
          </li>
          <li className="fs-14 text-justify my-10 text-white">Usage Data</li>
        </ul>
        <Typography className="fs-16">Usage Data</Typography>
        <Typography className="fs-14">
          Usage Data is collected automatically when using the Service.
        </Typography>
        <Typography className="fs-14">
          Usage Data may include information such as Your Device's Internet
          Protocol address (e.g. IP address), browser type, browser version, the
          pages of our Service that You visit, the time and date of Your visit,
          the time spent on those pages, unique device identifiers and other
          diagnostic data.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          When You access the Service by or through a mobile device, We may
          collect certain information automatically, including, but not limited
          to, the type of mobile device You use, Your mobile device unique ID,
          the IP address of Your mobile device, Your mobile operating system,
          the type of mobile Internet browser You use, unique device identifiers
          and other diagnostic data.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We also collect your blockchain address, which may become associated
          with Personal Data when you use our Service.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We may also collect information that Your browser sends whenever You
          visit our Service or when You access the Service by or through a
          mobile device.
        </Typography>
        <Typography className="fs-16">
          Information from Third-Party Social Media Services
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Company allows You to create an account and log in to use the
          Service through the following Third-party Social Media Services:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">Google</li>
          <li className="fs-14 text-justify my-10 text-white">Facebook</li>
          <li className="fs-14 text-justify my-10 text-white">Twitter</li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          If You decide to register through or otherwise grant us access to a
          Third-Party Social Media Service, We may collect Personal data that is
          already associated with Your Third-Party Social Media Service's
          account, such as Your name, Your email address, Your activities or
          Your contact list associated with that account.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You may also have the option of sharing additional information with
          the Company through Your Third-Party Social Media Service's account.
          If You choose to provide such information and Personal Data, during
          registration or otherwise, You are giving the Company permission to
          use, share, and store it in a manner consistent with this Privacy
          Policy.
        </Typography>
        <Typography className="fs-16">
          Information Collected while Using the Application
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          While using Our Application, in order to provide features of Our
          Application, We may collect, with Your prior permission:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            Information regarding your location
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Information from your Device's phone book (contacts list)
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Pictures and other information from your Device's camera and photo
            library
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Information Collected by Our Servers. To provide our Service and
            make it more useful to you, we (or a third party service provider)
            collect information from you, including, but not limited to, your
            browser type, operating system, Internet Protocol (“IP”) address,
            mobile device ID, blockchain address, wallet type, and date/time
            stamps.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            We use cookies to collect information. We may use both session
            Cookies (which expire once you close your web browser) and
            persistent Cookies (which stay on your computer until you delete
            them) to analyze how users interact with our Service, make
            improvements to our product quality, and provide users with a more
            personalized experience.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Public Information Observed from Blockchains. We collect data from
            activity that is publicly visible and/or accessible on blockchains.
            This may include blockchain addresses and information regarding
            purchases, sales, or transfers of NFTs, which may then be associated
            with other data you have provided to us.
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          We use this information to provide features of Our Service, to improve
          and customize Our Service. The information may be uploaded to the
          Company's servers and/or a Service Provider's server or it may be
          simply stored on Your device.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You can enable or disable access to this information at any time,
          through Your Device settings.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">Use of Your Personal Data</Typography>

        <Typography className="fs-14 text-justify my-10">
          The Company may use Personal Data for the following purposes:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">To provide and maintain our Service</b> ,
            including to monitor the usage of our Service.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">To manage Your Account:</b> to manage Your
            registration as a user of the Service. The Personal Data You provide
            can give You access to different functionalities of the Service that
            are available to You as a registered user.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">For the performance of a contract:</b>
            the development, compliance and undertaking of the purchase contract
            for the products, items or services You have purchased or of any
            other contract with Us through the Service.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">To contact You:</b> To contact You by email,
            telephone calls, SMS, or other equivalent forms of electronic
            communication, such as a mobile application's push notifications
            regarding updates or informative communications related to the
            functionalities, products or contracted services, including the
            security updates, when necessary or reasonable for their
            implementation.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">To provide You</b> with news, special offers
            and general information about other goods, services and events which
            we offer that are similar to those that you have already purchased
            or enquired about unless You have opted not to receive such
            information.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">To manage Your requests:</b> To attend and
            manage Your requests to Us.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">For business transfers:</b> We may use Your
            information to evaluate or conduct a merger, divestiture,
            restructuring, reorganization, dissolution, or other sale or
            transfer of some or all of Our assets, whether as a going concern or
            as part of bankruptcy, liquidation, or similar proceeding, in which
            Personal Data held by Us about our Service users is among the assets
            transferred.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Terms of Service:</b> To investigate and
            address conduct that may violate our Terms of Service;
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">For other purposes:</b> We may use Your
            information for other purposes, such as data analysis, identifying
            usage trends, determining the effectiveness of our promotional
            campaigns and to evaluate and improve our Service, products,
            services, marketing and your experience.
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          We may share Your personal information in the following situations:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">With Service Providers:</b> We may share Your
            personal information with Service Providers to monitor and analyze
            the use of our Service, for payment processing, to contact You.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">For business transfers:</b> We may share or
            transfer Your personal information in connection with, or during
            negotiations of, any merger, sale of Company assets, financing, or
            acquisition of all or a portion of Our business to another company.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">With Affiliates:</b> We may share Your
            information with Our affiliates, in which case we will require those
            affiliates to honor this Privacy Policy. Affiliates include Our
            parent company and any other subsidiaries, joint venture partners or
            other companies that We control or that are under common control
            with Us.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">With business partners:</b> We may share Your
            information with Our business partners to offer You certain
            products, services or promotions.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">With other users:</b> when You share personal
            information or otherwise interact in the public areas with other
            users, such information may be viewed by all users and may be
            publicly distributed outside. If You interact with other users or
            register through a Third-Party Social Media Service, Your contacts
            on the Third-Party Social Media Service may see Your name, profile,
            pictures and description of Your activity. Similarly, other users
            will be able to view descriptions of Your activity, communicate with
            You and view Your profile.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">With Your consent:</b> We may disclose Your
            personal information for any other purpose with Your consent.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Siki Creators.</b> In some circumstances, Siki
            may share your contact information with Siki Creators to facilitate
            the delivery of Additional Items under the Terms of Use.
          </li>
        </ul>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Retention of Your Personal Data
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Company will retain Your Personal Data only for as long as is
          necessary for the purposes set out in this Privacy Policy. We will
          retain and use Your Personal Data to the extent necessary to comply
          with our legal obligations (for example, if we are required to retain
          your data to comply with applicable laws), resolve disputes, and
          enforce our legal agreements and policies. The Company will also
          retain Usage Data for internal analysis purposes. Usage Data is
          generally retained for a shorter period of time, except when this data
          is used to strengthen the security or to improve the functionality of
          Our Service, or We are legally obligated to retain this data for
          longer time periods.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Transfer of Your Personal Data
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Your information, including Personal Data, is processed at the
          Company's operating offices and in any other places where the parties
          involved in the processing are located. It means that this information
          may be transferred to — and maintained on — computers located outside
          of Your state, province, country or other governmental jurisdiction
          where the data protection laws may differ than those from Your
          jurisdiction.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Your consent to this Privacy Policy followed by Your submission of
          such information represents Your agreement to that transfer.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Company will take all steps reasonably necessary to ensure that
          Your data is treated securely and in accordance with this Privacy
          Policy and no transfer of Your Personal Data will take place to an
          organization or a country unless there are adequate controls in place
          including the security of Your data and other personal information.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Disclosure of Your Personal Data
        </Typography>
        <Typography className="fs-18">Business Transactions</Typography>
        <Typography className="fs-14 text-justify my-10">
          If the Company is involved in a merger, acquisition or asset sale,
          Your Personal Data may be transferred. We will provide notice before
          Your Personal Data is transferred and becomes subject to a different
          Privacy Policy.
        </Typography>
        <Typography className="fs-18">Law enforcement</Typography>
        <Typography className="fs-14 text-justify my-10">
          Under certain circumstances, the Company may be required to disclose
          Your Personal Data if required to do so by law or in response to valid
          requests by public authorities (e.g. a court or a government agency).
        </Typography>
        <Typography className="fs-18">Other legal requirements</Typography>
        <Typography className="fs-14 text-justify my-10">
          The Company may disclose Your Personal Data in the good faith belief
          that such action is necessary to:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            Comply with a legal obligation
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Protect and defend the rights or property of the Company
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Prevent or investigate possible wrongdoing in connection with the
            Service
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Protect the personal safety of Users of the Service or the public
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Protect against legal liability
          </li>
        </ul>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Security of Your Personal Data
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The security of Your Personal Data is important to Us, but remember
          that no method of transmission over the Internet, or method of
          electronic storage is 100% secure. While We strive to use commercially
          acceptable means to protect Your Personal Data, We cannot guarantee
          its absolute security.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Detailed Information on the Processing of Your Personal Data
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Service Providers We use may have access to Your Personal Data.
          These third-party vendors collect, store, use, process and transfer
          information about Your activity on Our Service in accordance with
          their Privacy Policies.
        </Typography>
        <Typography className="fs-18">Analytics</Typography>
        <Typography className="fs-14 text-justify my-10">
          We may use third-party Service providers to monitor and analyze the
          use of our Service.
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Google Analytics</b>
            <br />
            Google Analytics is a web analytics service offered by Google that
            tracks and reports website traffic. Google uses the data collected
            to track and monitor the use of our Service. This data is shared
            with other Google services. Google may use the collected data to
            contextualize and personalize the ads of its own advertising
            network. You may opt-out of certain Google Analytics features
            through your mobile device settings, such as your device advertising
            settings or by following the instructions provided by Google in
            their Privacy Policy:{" "}
            <a href="https://policies.google.com/privacy">
              https://policies.google.com/privacy
            </a>{" "}
            For more information on the privacy practices of Google, please
            visit the Google Privacy & Terms web page:
            <a href="https://policies.google.com/privacy">
              https://policies.google.com/privacy
            </a>
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Firebase</b>
            <br />
            Firebase is an analytics service provided by Google Inc. You may
            opt-out of certain Firebase features through your mobile device
            settings, such as your device advertising settings or by following
            the instructions provided by Google in their Privacy Policy:
            <a href="https://policies.google.com/privacy">
              https://policies.google.com/privacy
            </a>{" "}
            We also encourage you to review the Google's policy for safeguarding
            your data:{" "}
            <a href="https://support.google.com/analytics/answer/6004245">
              https://support.google.com/analytics/answer/6004245
            </a>{" "}
            For more information on what type of information Firebase collects,
            please visit the How Google uses data when you use our partners'
            sites or apps webpage:
            <a href="https://policies.google.com/technologies/partner-sites">
              https://policies.google.com/technologies/partner-sites
            </a>
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Mixpanel</b>
            <br />
            Mixpanel is provided by Mixpanel Inc. You can prevent Mixpanel from
            using your information for analytics purposes by opting-out. To
            opt-out of Mixpanel service, please visit this page:
            <a href="https://mixpanel.com/optout/">
              https://mixpanel.com/optout/
            </a>{" "}
            For more information on what type of information Mixpanel collects,
            please visit the Terms of Use page of Mixpanel:
            <a href="https://mixpanel.com/terms/">
              https://mixpanel.com/terms/
            </a>
          </li>
        </ul>
        <Typography className="fs-18">Email Marketing</Typography>
        <Typography className="fs-14 text-justify my-10">
          We may use Your Personal Data to contact You with newsletters,
          marketing or promotional materials and other information that may be
          of interest to You. You may opt-out of receiving any, or all, of these
          communications from Us by following the unsubscribe link or
          instructions provided in any email We send or by contacting Us.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We may use Email Marketing Service Providers to manage and send emails
          to You.
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Mailchimp</b>
            <br />
            Mailchimp is an email marketing sending service provided by The
            Rocket Science Group LLC. For more information on the privacy
            practices of Mailchimp, please visit their Privacy policy:{" "}
            <a href="https://mailchimp.com/legal/privacy/">
              https://mailchimp.com/legal/privacy/
            </a>
          </li>
        </ul>
        <Typography className="fs-18">Payments</Typography>
        <Typography className="fs-14 text-justify my-10">
          We may provide paid products and/or services within the Service. In
          that case, we may use third-party services for payment processing
          (e.g. payment processors).
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We will not store or collect Your payment card details. That
          information is provided directly to Our third-party payment processors
          whose use of Your personal information is governed by their Privacy
          Policy. These payment processors adhere to the standards set by
          PCI-DSS as managed by the PCI Security Standards Council, which is a
          joint effort of brands like Visa, Mastercard, American Express and
          Discover. PCI-DSS requirements help ensure the secure handling of
          payment information.
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Moonpay</b>
            <br />
            Their Privacy Policy can be viewed at{" "}
            <a href="https://www.moonpay.com/legal/privacy_policy">
              https://www.moonpay.com/legal/privacy_policy
            </a>
          </li>
        </ul>
      </div>
      <div className="my-10">
        <Typography className="fs-20">GDPR Privacy</Typography>
        <Typography className="fs-18">
          Legal Basis for Processing Personal
        </Typography>
        <Typography className="fs-18">Data under GDPR</Typography>
        <Typography className="fs-14 text-justify my-10">
          We may process Personal Data under the following conditions:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Consent:</b> You have given Your consent for
            processing Personal Data for one or more specific purposes.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Performance of a contract:</b>
            Provision of Personal Data is necessary for the performance of an
            agreement with You and/or for any pre-contractual obligations
            thereof.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Legal obligations:</b> Processing Personal
            Data is necessary for compliance with a legal obligation to which
            the Company is subject.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Vital interests:</b> Processing Personal Data
            is necessary in order to protect Your vital interests or of another
            natural person.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Public interests:</b> Processing Personal Data
            is related to a task that is carried out in the public interest or
            in the exercise of official authority vested in the Company.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Legitimate interests:</b> Processing Personal
            Data is necessary for the purposes of the legitimate interests
            pursued by the Company.
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          In any case, the Company will gladly help to clarify the specific
          legal basis that applies to the processing, and in particular whether
          the provision of Personal Data is a statutory or contractual
          requirement, or a requirement necessary to enter into a contract.
        </Typography>
        <Typography className="fs-18">Your Rights under the GDPR</Typography>
        <Typography className="fs-14 text-justify my-10">
          The Company undertakes to respect the confidentiality of Your Personal
          Data and to guarantee You can exercise Your rights.
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Request access to Your Personal Data.</b> The
            right to access, update or delete the information We have on You.
            Whenever made possible, you can access, update or request deletion
            of Your Personal Data directly within Your account settings section.
            If you are unable to perform these actions yourself, please contact
            Us to assist You. This also enables You to receive a copy of the
            Personal Data We hold about You.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              Request correction of the Personal Data that We hold about You.
            </b>{" "}
            You have the right to have any incomplete or inaccurate information
            We hold about You corrected.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              Object to processing of Your Personal Data.
            </b>{" "}
            This right exists where We are relying on a legitimate interest as
            the legal basis for Our processing and there is something about Your
            particular situation, which makes You want to object to our
            processing of Your Personal Data on this ground. You also have the
            right to object where We are processing Your Personal Data for
            direct marketing purposes.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Request erasure of Your Personal Data.</b> You
            have the right to ask Us to delete or remove Personal Data when
            there is no good reason for Us to continue processing it.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              AcRequest the transfer of Your Personal Data.ount
            </b>{" "}
            We will provide to You, or to a third-party You have chosen, Your
            Personal Data in a structured, commonly used, machine-readable
            format. Please note that this right only applies to automated
            information which You initially provided consent for Us to use or
            where We used the information to perform a contract with You.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Withdraw Your consent.</b> You have the right
            to withdraw Your consent on using your Personal Data. If You
            withdraw Your consent, We may not be able to provide You with access
            to certain specific functionalities of the Service.
          </li>
        </ul>
        <Typography className="fs-18">
          Exercising of Your GDPR Data Protection Rights
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You may exercise Your rights of access, rectification, cancellation
          and opposition by contacting Us. Please note that we may ask You to
          verify Your identity before responding to such requests. If You make a
          request, We will try our best to respond to You as soon as possible.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You have the right to complain to a Data Protection Authority about
          Our collection and use of Your Personal Data. For more information, if
          You are in the European Economic Area (EEA), please contact Your local
          data protection authority in the EEA.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">CCPA Privacy</Typography>
        <Typography className="fs-14 text-justify my-10">
          This privacy notice section for California residents supplements the
          information contained in Our Privacy Policy and it applies solely to
          all visitors, users, and others who reside in the State of California.
        </Typography>
        <Typography className="fs-18">
          Categories of Personal Information Collected
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We collect information that identifies, relates to, describes,
          references, is capable of being associated with, or could reasonably
          be linked, directly or indirectly, with a particular Consumer or
          Device. The following is a list of categories of personal information
          which we may collect or may have been collected from California
          residents within the last twelve (12) months.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Please note that the categories and examples provided in the list
          below are those defined in the CCPA. This does not mean that all
          examples of that category of personal information were in fact
          collected by Us, but reflects our good faith belief to the best of our
          knowledge that some of that information from the applicable category
          may be and may have been collected. For example, certain categories of
          personal information would only be collected if You provided such
          personal information directly to Us.
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Category A: Identifiers.</b>
            <br /> Examples: A real name, alias, postal address, unique personal
            identifier, online identifier, Internet Protocol address, email
            address, account name, driver's license number, passport number, or
            other similar identifiers. Collected: Yes.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              Category B: Personal information categories listed in the
              California Customer Records statute (Cal. Civ. Code § 1798.80(e)).
            </b>
            <br />
            Examples: A name, signature, Social Security number, physical
            characteristics or description, address, telephone number, passport
            number, driver's license or state identification card number,
            insurance policy number, education, employment, employment history,
            bank account number, credit card number, debit card number, or any
            other financial information, medical information, or health
            insurance information. Some personal information included in this
            category may overlap with other categories. Collected: Yes.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              Category C: Protected classification characteristics under
              California or federal law.
            </b>
            <br /> Examples: Age (40 years or older), race, color, ancestry,
            national origin, citizenship, religion or creed, marital status,
            medical condition, physical or mental disability, sex (including
            gender, gender identity, gender expression, pregnancy or childbirth
            and related medical conditions), sexual orientation, veteran or
            military status, genetic information (including familial genetic
            information). Collected: No.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Category D: Commercial information.</b>
            <br /> Examples: Records and history of products or services
            purchased or considered. Collected: Yes.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Category E: Biometric information.</b>
            <br /> Examples: Genetic, physiological, behavioral, and biological
            characteristics, or activity patterns used to extract a template or
            other identifier or identifying information, such as, fingerprints,
            faceprints, and voiceprints, iris or retina scans, keystroke, gait,
            or other physical patterns, and sleep, health, or exercise data.
            Collected: No.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              Category F: Internet or other similar network activity.
            </b>
            <br />
            Examples: Interaction with our Service or advertisement. Collected:
            Yes.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Category G: Geolocation data.</b>
            <br />
            Examples: Approximate physical location. Collected: Yes.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Category H: Sensory data.</b>
            <br /> Examples: Audio, electronic, visual, thermal, olfactory, or
            similar information. Collected: No.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              Category I: Professional or employment-related information.
            </b>
            <br />
            Examples: Current or past job history or performance evaluations.
            Collected: No.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              Category J: Non-public education information (per the Family
              Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34
              C.F.R. Part 99)).
            </b>
            <br /> Examples: Education records directly related to a student
            maintained by an educational institution or party acting on its
            behalf, such as grades, transcripts, class lists, student schedules,
            student identification codes, student financial information, or
            student disciplinary records. Collected: No.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              Category K: Inferences drawn from other personal information.
            </b>
            <br /> Examples: Profile reflecting a person's preferences,
            characteristics, psychological trends, predispositions, behavior,
            attitudes, intelligence, abilities, and aptitudes. Collected: No.
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          Under CCPA, personal information does not include:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            Publicly available information from government records
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Deidentified or aggregated consumer information
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Information excluded from the CCPA's scope, such as:
          </li>

          <ul>
            <li className="fs-14 text-justify my-10 text-white">
              Health or medical information covered by the Health Insurance
              Portability and Accountability Act of 1996 (HIPAA) and the
              California Confidentiality of Medical Information Act (CMIA) or
              clinical trial data
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Personal Information covered by certain sector-specific privacy
              laws, including the Fair Credit Reporting Act (FRCA), the
              Gramm-Leach-Bliley Act (GLBA) or California Financial Information
              Privacy Act (FIPA), and the Driver's Privacy Protection Act of
              1994
            </li>
          </ul>
        </ul>
      </div>
      <div className="my-10">
        <Typography className="fs-18">
          Sources of Personal Information
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We obtain the categories of personal information listed above from the
          following categories of sources:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Directly from You.</b> For example, from the
            forms You complete on our Service, preferences You express or
            provide through our Service, or from Your purchases on our Service.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Indirectly from You.</b> For example, from
            observing Your activity on our Service.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">Automatically from You.</b>
            For example, through cookies We or our Service Providers set on Your
            Device as You navigate through our Service.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">From Service Providers.</b> For example,
            third-party vendors to monitor and analyze the use of our Service,
            third-party vendors for payment processing, or other third-party
            vendors that We use to provide the Service to You.
          </li>
        </ul>
      </div>
      <div className="my-10">
        <Typography className="fs-18">
          Use of Personal Information for Business Purposes or Commercial
          Purposes
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We may use or disclose personal information We collect for "business
          purposes" or "commercial purposes" (as defined under the CCPA), which
          may include the following examples:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            To operate our Service and provide You with our Service.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            To provide You with support and to respond to Your inquiries,
            including to investigate and address Your concerns and monitor and
            improve our Service.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            To fulfill or meet the reason You provided the information. For
            example, if You share Your contact information to ask a question
            about our Service, We will use that personal information to respond
            to Your inquiry. If You provide Your personal information to
            purchase a product or service, We will use that information to
            process Your payment and facilitate delivery.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            To respond to law enforcement requests and as required by applicable
            law, court order, or governmental regulations.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            As described to You when collecting Your personal information or as
            otherwise set forth in the CCPA.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            For internal administrative and auditing purposes.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            To detect security incidents and protect against malicious,
            deceptive, fraudulent or illegal activity, including, when
            necessary, to prosecute those responsible for such activities.
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          Please note that the examples provided above are illustrative and not
          intended to be exhaustive. For more details on how we use this
          information, please refer to the "Use of Your Personal Data" section.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          f We decide to collect additional categories of personal information
          or use the personal information We collected for materially different,
          unrelated, or incompatible purposes We will update this Privacy
          Policy.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-18">
          Disclosure of Personal Information for Business Purposes or Commercial
          Purposes
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We may use or disclose and may have used or disclosed in the last
          twelve (12) months the following categories of personal information
          for business or commercial purposes:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            Category A: Identifiers
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Category B: Personal information categories listed in the California
            Customer Records statute (Cal. Civ. Code § 1798.80(e))
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Category D: Commercial information
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Category F: Internet or other similar network activity
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Category G: Geolocation data
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          Please note that the categories listed above are those defined in the
          CCPA. This does not mean that all examples of that category of
          personal information were in fact disclosed, but reflects our good
          faith belief to the best of our knowledge that some of that
          information from the applicable category may be and may have been
          disclosed.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          When We disclose personal information for a business purpose or a
          commercial purpose, We enter a contract that describes the purpose and
          requires the recipient to both keep that personal information
          confidential and not use it for any purpose except performing the
          contract.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-18">Sale of Personal Information</Typography>
        <Typography className="fs-14 text-justify my-10">
          As defined in the CCPA, "sell" and "sale" mean selling, renting,
          releasing, disclosing, disseminating, making available, transferring,
          or otherwise communicating orally, in writing, or by electronic or
          other means, a consumer's personal information by the business to a
          third party for valuable consideration. This means that We may have
          received some kind of benefit in return for sharing personal
          information, but not necessarily a monetary benefit.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Please note that the categories listed below are those defined in the
          CCPA. This does not mean that all examples of that category of
          personal information were in fact sold, but reflects our good faith
          belief to the best of our knowledge that some of that information from
          the applicable category may be and may have been shared for value in
          return.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We may sell and may have sold in the last twelve (12) months the
          following categories of personal information:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            Category A: Identifiers
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Category B: Personal information categories listed in the California
            Customer Records statute (Cal. Civ. Code § 1798.80(e))
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Category D: Commercial information
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Category F: Internet or other similar network activity
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Category G: Geolocation data
          </li>
        </ul>
      </div>
      <div className="my-10">
        <Typography className="fs-18">Share of Personal Information</Typography>
        <Typography className="fs-14 text-justify my-10">
          We may share Your personal information identified in the above
          categories with the following categories of third parties:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            Service Providers
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Payment processors
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Our affiliates
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Our business partners
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Third party vendors to whom You or Your agents authorize Us to
            disclose Your personal information in connection with products or
            services We provide to You
          </li>
        </ul>
      </div>
      <div className="my-10">
        <Typography className="fs-18">
          Sale of Personal Information of Minors Under 16 Years of Age
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We do not sell the personal information of Consumers We actually know
          are less than 16 years of age, unless We receive affirmative
          authorization (the "right to opt-in") from either the Consumer who is
          between 13 and 16 years of age, or the parent or guardian of a
          Consumer less than 13 years of age. Consumers who opt-in to the sale
          of personal information may opt-out of future sales at any time. To
          exercise the right to opt-out, You (or Your authorized representative)
          may submit a request to Us by contacting Us.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          If You have reason to believe that a child under the age of 13 (or 16)
          has provided Us with personal information, please contact Us with
          sufficient detail to enable Us to delete that information.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-18">Your Rights under the CCPA</Typography>
        <Typography className="fs-14 text-justify my-10">
          The CCPA provides California residents with specific rights regarding
          their personal information. If You are a resident of California, You
          have the following rights:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">The right to notice.</b> You have the right to
            be notified which categories of Personal Data are being collected
            and the purposes for which the Personal Data is being used.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">The right to request.</b>
            Under CCPA, You have the right to request that We disclose
            information to You about Our collection, use, sale, disclosure for
            business purposes and share of personal information. Once We receive
            and confirm Your request, We will disclose to You:
          </li>
          <ul>
            <li className="fs-14 text-justify my-10 text-white">
              The categories of personal information We collected about You
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              The categories of sources for the personal information We
              collected about You
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Our business or commercial purpose for collecting or selling that
              personal information
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              If we sold Your personal information or disclosed Your personal
              information for a business purpose, We will disclose to You:
            </li>
            <ul>
              <li className="fs-14 text-justify my-10 text-white">
                The categories of personal information categories sold
              </li>
              <li className="fs-14 text-justify my-10 text-white">
                The categories of personal information categories disclosed
              </li>
            </ul>
          </ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">
              The right to say no to the sale of Personal Data (opt-out).
            </b>{" "}
            You have the right to direct Us to not sell Your personal
            information. To submit an opt-out request please contact Us.
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">The right to delete Personal Data.</b> You
            have the right to request the deletion of Your Personal Data,
            subject to certain exceptions. Once We receive and confirm Your
            request, We will delete (and direct Our Service Providers to delete)
            Your personal information from our records, unless an exception
            applies. We may deny Your deletion request if retaining the
            information is necessary for Us or Our Service Providers to:
          </li>
          <ul>
            <li className="fs-14 text-justify my-10 text-white">
              Complete the transaction for which We collected the personal
              information, provide a good or service that You requested, take
              actions reasonably anticipated within the context of our ongoing
              business relationship with You, or otherwise perform our contract
              with You.
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Detect security incidents, protect against malicious, deceptive,
              fraudulent, or illegal activity, or prosecute those responsible
              for such activities.
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Debug products to identify and repair errors that impair existing
              intended functionality.
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              xercise free speech, ensure the right of another consumer to
              exercise their free speech rights, or exercise another right
              provided for by law.
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Comply with the California Electronic Communications Privacy Act
              (Cal. Penal Code § 1546 et. seq.).
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              research in the public interest that adheres to all other
              applicable ethics and privacy laws, when the information's
              deletion may likely render impossible or seriously impair the
              research's achievement, if You previously provided informed
              consent.
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Enable solely internal uses that are reasonably aligned with
              consumer expectations based on Your relationship with Us.
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Comply with a legal obligation.
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Make other internal and lawful uses of that information that are
              compatible with the context in which You provided it.
            </li>
          </ul>
          <li className="fs-14 text-justify my-10 text-white">
            <b className="fs-16 ">The right not to be discriminated against.</b>{" "}
            You have the right not to be discriminated against for exercising
            any of Your consumer's rights, including by:
          </li>
          <ul>
            <li className="fs-14 text-justify my-10 text-white">
              Denying goods or services to You
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Charging different prices or rates for goods or services,
              including the use of discounts or other benefits or imposing
              penalties
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Providing a different level or quality of goods or services to You
            </li>
            <li className="fs-14 text-justify my-10 text-white">
              Suggesting that You will receive a different price or rate for
              goods or services or a different level or quality of goods or
              services
            </li>
          </ul>
        </ul>
      </div>
      <div className="my-10">
        <Typography className="fs-18">
          Exercising Your CCPA Data Protection Rights
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          In order to exercise any of Your rights under the CCPA, and if You are
          a California resident, You can contact Us:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            By email: contact@siki.io
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            By visiting this page on our website:{" "}
            <a href="https://siki.io">siki.io</a>
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            By mail: Siki Holdings, Inc., 1111 Lincoln Rd, Miami Beach, FL 33139
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          Only You, or a person registered with the California Secretary of
          State that You authorize to act on Your behalf, may make a verifiable
          request related to Your personal information.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Your request to Us must:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            Provide sufficient information that allows Us to reasonably verify
            You are the person about whom We collected personal information or
            an authorized representative
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Describe Your request with sufficient detail that allows Us to
            properly understand, evaluate, and respond to it
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          We cannot respond to Your request or provide You with the required
          information if we cannot:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            Verify Your identity or authority to make the request
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            And confirm that the personal information relates to You
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          We will disclose and deliver the required information free of charge
          within 45 days of receiving Your verifiable request. The time period
          to provide the required information may be extended once by an
          additional 45 days when reasonable necessary and with prior notice.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Any disclosures We provide will only cover the 12-month period
          preceding the verifiable request's receipt. For data portability
          requests, We will select a format to provide Your personal information
          that is readily useable and should allow You to transmit the
          information from one entity to another entity without hindrance.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-18">
          Do Not Sell My Personal Information
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You have the right to opt-out of the sale of Your personal
          information. Once We receive and confirm a verifiable consumer request
          from You, we will stop selling Your personal information. To exercise
          Your right to opt-out, please contact Us.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Service Providers we partner with (for example, our analytics or
          advertising partners) may use technology on the Service that sells
          personal information as defined by the CCPA law. If you wish to opt
          out of the use of Your personal information for interest-based
          advertising purposes and these potential sales as defined under CCPA
          law, you may do so by following the instructions below.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Please note that any opt out is specific to the browser You use. You
          may need to opt out on every browser that You use.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-18">Website</Typography>
        <Typography className="fs-14 text-justify my-10">
          You can opt out of receiving ads that are personalized as served by
          our Service Providers by following our instructions presented on the
          Service:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            The NAI's opt-out platform:{" "}
            <a href="http://www.networkadvertising.org/choices/">
              http://www.networkadvertising.org/choices/
            </a>
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            The EDAA's opt-out platform{" "}
            <a href="http://www.youronlinechoices.com/">
              http://www.youronlinechoices.com/
            </a>
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            The NAI's opt-out platform:{" "}
            <a href="http://www.networkadvertising.org/choices/">
              http://www.networkadvertising.org/choices/
            </a>
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          The opt out will place a cookie on Your computer that is unique to the
          browser You use to opt out. If you change browsers or delete the
          cookies saved by your browser, You will need to opt out again.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-18">Mobile Devices</Typography>
        <Typography className="fs-14 text-justify my-10">
          Your mobile device may give You the ability to opt out of the use of
          information about the apps You use in order to serve You ads that are
          targeted to Your interests:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            "Opt out of Interest-Based Ads" or "Opt out of Ads Personalization"
            on Android devices
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            "Limit Ad Tracking" on iOS devices
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          You can also stop the collection of location information from Your
          mobile device by changing the preferences on Your mobile device.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          "Do Not Track" Policy as Required by California Online Privacy
          Protection Act (CalOPPA)
        </Typography>

        <Typography className="fs-14 text-justify my-10">
          Our Service does not respond to Do Not Track signals.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          However, some third party websites do keep track of Your browsing
          activities. If You are visiting such websites, You can set Your
          preferences in Your web browser to inform websites that You do not
          want to be tracked. You can enable or disable DNT by visiting the
          preferences or settings page of Your web browser.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">Children's Privacy</Typography>
        <Typography className="fs-14 text-justify my-10">
          The Service may contain content appropriate for children under the age
          of 13. As a parent, you should know that through the Service children
          under the age of 13 may participate in activities that involve the
          collection or use of personal information. We use reasonable efforts
          to ensure that before we collect any personal information from a
          child, the child's parent receives notice of and consents to our
          personal information practices.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We also may limit how We collect, use, and store some of the
          information of Users between 13 and 18 years old. In some cases, this
          means We will be unable to provide certain functionality of the
          Service to these Users. If We need to rely on consent as a legal basis
          for processing Your information and Your country requires consent from
          a parent, We may require Your parent's consent before We collect and
          use that information.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We may ask a User to verify its date of birth before collecting any
          personal information from them. If the User is under the age of 13,
          the Service will be either blocked or redirected to a parental consent
          process.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Information Collected from Children Under the Age of 13
        </Typography>

        <Typography className="fs-14 text-justify my-10">
          The Company may collect and store persistent identifiers such as
          cookies or IP addresses from Children without parental consent for the
          purpose of supporting the internal operation of the Service.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We may collect and store other personal information about children if
          this information is submitted by a child with prior parent consent or
          by the parent or guardian of the child.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          The Company may collect and store the following types of personal
          information about a child when submitted by a child with prior
          parental consent or by the parent or guardian of the child:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            First and/or last name
          </li>
          <li className="fs-14 text-justify my-10 text-white">Date of birth</li>
          <li className="fs-14 text-justify my-10 text-white">Gender</li>
          <li className="fs-14 text-justify my-10 text-white">Grade level</li>
          <li className="fs-14 text-justify my-10 text-white">Email address</li>
          <li className="fs-14 text-justify my-10 text-white">
            Telephone number
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Parent's or guardian's name
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Parent's or guardian's email address
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          For further details on the information We might collect, You can refer
          to the "Types of Data Collected" section of this Privacy Policy. We
          follow our standard Privacy Policy for the disclosure of personal
          information collected from and about children.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-18">Parental Access</Typography>

        <Typography className="fs-14 text-justify my-10">
          A parent who has already given the Company permission to collect and
          use his child personal information can, at any time:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            Review, correct or delete the child's personal information
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            Discontinue further collection or use of the child's personal
            information
          </li>
        </ul>
        <Typography className="fs-14 text-justify my-10">
          To make such a request, You can write to Us using the contact
          information provided in this Privacy Policy.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Your California Privacy Rights (California's Shine the Light law)
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Under California Civil Code Section 1798 (California's Shine the Light
          law), California residents with an established business relationship
          with us can request information once a year about sharing their
          Personal Data with third parties for the third parties' direct
          marketing purposes. If you'd like to request more information under
          the California Shine the Light law, and if You are a California
          resident, You can contact Us using the contact information provided
          below.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          California Privacy Rights for Minor Users (California Business and
          Professions Code Section 22581)
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          California Business and Professions Code section 22581 allow
          California residents under the age of 18 who are registered users of
          online sites, services or applications to request and obtain removal
          of content or information they have publicly posted.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          To request removal of such data, and if You are a California resident,
          You can contact Us using the contact information provided below, and
          include the email address associated with Your account.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          Be aware that Your request does not guarantee complete or
          comprehensive removal of content or information posted online and that
          the law may not permit or require removal in certain circumstances.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">Links to Other Websites</Typography>
        <Typography className="fs-14 text-justify my-10">
          Our Service may contain links to other websites that are not operated
          by Us. If You click on a third party link, You will be directed to
          that third party's site. We strongly advise You to review the Privacy
          Policy of every site You visit.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We have no control over and assume no responsibility for the content,
          privacy policies or practices of any third party sites or services.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">Third-Party Wallets. </Typography>
        <Typography className="fs-14 text-justify my-10">
          To use our Service, you must use a third-party wallet which allows you
          to engage in transactions on public blockchains. Your interactions
          with any third-party wallet provider are governed by the applicable
          terms of service and privacy policy of that third party.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">
          Changes to this Privacy Policy{" "}
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We may update Our Privacy Policy from time to time. We will notify You
          of any changes by posting the new Privacy Policy on this page.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          We will let You know via email and/or a prominent notice on Our
          Service, prior to the change becoming effective and update the "Last
          updated" date at the top of this Privacy Policy.
        </Typography>
        <Typography className="fs-14 text-justify my-10">
          You are advised to review this Privacy Policy periodically for any
          changes. Changes to this Privacy Policy are effective when they are
          posted on this page.
        </Typography>
      </div>
      <div className="my-10">
        <Typography className="fs-20">Contact Us</Typography>

        <Typography className="fs-14 text-justify my-10">
          If you have any questions about this Privacy Policy, You can contact
          us:
        </Typography>
        <ul>
          <li className="fs-14 text-justify my-10 text-white">
            By email: contact@siki.io
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            By visiting this page on our website:{" "}
            <a href="https://siki.io">siki.io</a>
          </li>
          <li className="fs-14 text-justify my-10 text-white">
            By mail: Siki Holdings, Inc., 1111 Lincoln Rd, Miami Beach, FL 33139
          </li>
        </ul>
      </div>
    </Box>
  );
}
